import { Link } from "react-router-dom";

// Nouveau besoin propre au web : sur natif, une route inconnue était
// impossible. Ici l'utilisateur peut taper n'importe quelle URL.

export function NotFound() {
  return (
    <section className="flex h-dvh flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="font-extrabold text-3xl text-navy-800">Page introuvable</h1>
      <p className="text-gray-500">Cette adresse ne correspond à aucun écran d'Alomain.</p>
      <Link
        to="/"
        className="rounded-btn bg-navy-800 px-5 py-3 font-bold text-white transition-colors hover:bg-navy-600"
      >
        Retour à l'accueil
      </Link>
    </section>
  );
}
